// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"cb62e388","301":"d41746cd","489":"3e5aa5c5","787":"4e207633","794":"e25baec6"}[chunkId] + ".chunk.js";
};